document.addEventListener('DOMContentLoaded', function () {

  const loader = document.getElementById('loading-screen');

  if (!loader) return;


  /*
   * If this session has already shown
   * the loading screen, remove it immediately.
   */

  if (
    document.documentElement.classList.contains(
      'loading-screen-seen'
    )
  ) {

    loader.remove();

    return;

  }


  /*
   * First visit:
   * remember that the loading screen
   * has now been shown.
   */

  try {

    sessionStorage.setItem(
      'webhausLoadingScreenShown',
      'true'
    );

  } catch (error) {
    // Ignore storage errors
  }


  /*
   * Wait for the page and its resources
   * to finish loading.
   */

  window.addEventListener('load', function () {

    loader.classList.add('is-hidden');


    const reveal = loader.dataset.screenReveal;


    let duration = 800;


    if (reveal === 'fade') {
      duration = 1300;
    }


    if (reveal === 'slide') {
      duration = 1500;
    }


    if (reveal === 'curtain') {
      duration = 1600;
    }


    if (reveal === 'clip') {
      duration = 1400;
    }


    setTimeout(function () {

      loader.remove();

    }, duration + 50);

  });

});